import React, { useState, useEffect } from 'react';
import { db } from '../../Firebase/Firebase';
import { collection, getDocs, query, where, doc, getDoc } from 'firebase/firestore';
import Slider from 'react-slick';
import * as FaIcons from 'react-icons/fa';
import './ServiciosMain.css';
import Navbar from '../../Components/NavBarAirbnbStyle';
import FloatingWhatsApp from '../../Components/whatsappbutton';
import Footer from '../../Components/footer';
import BotonFlotanteServicios from '../../Components/iconosFlotantes/servicioBotonFlotante';
import NavbarMobileVersion from '../../Components/NavBar/NavBarMobileVersion';
import NavBarServicios from '../../Components/NavBar/NavBarServicios';
import { useCategoriaServicio } from '../../Components/context/FiltroCategoriaServicioContext';
import { getAuth } from 'firebase/auth';
import NavBarMobileService from '../../Components/NavBar/NavBarMobileServices';

const ServiciosMain = () => {
  const [servicios, setServicios] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const { categoriaSeleccionado } = useCategoriaServicio();
  useEffect(() => {
    cargarServicios(categoriaSeleccionado)
    console.log(categoriaSeleccionado)
  }, [categoriaSeleccionado])

  const cargarServicios = async (categoria) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      const userId = user?.uid;

      const queryRef = categoria
        ? query(collection(db, 'servicios'), where('categoria', '==', categoria))
        : collection(db, 'servicios');

      const snapshot = await getDocs(queryRef);

      const serviciosList = await Promise.all(snapshot.docs.map(async (docSnap) => {
        const servicio = { id: docSnap.id, ...docSnap.data() };

        // Verificar si el usuario ha marcado como favorito
        if (userId) {
          const favRef = doc(db, 'servicios', servicio.id, 'favoritos', userId);
          const favDoc = await getDoc(favRef);
          servicio.esFavorito = favDoc.exists();
        } else {
          servicio.esFavorito = false;
        }

        // Obtener el conteo de favoritos
        const favsSnapshot = await getDocs(collection(db, 'servicios', servicio.id, 'favoritos'));
        servicio.conteoFavoritos = favsSnapshot.size;

        return servicio;
      }));

      setServicios(serviciosList);
    } catch (error) {
      console.error('Error cargando servicios:', error);
    }
  };


  // Opciones del slider react-slick
  const settings = {
    dots: false,
    infinite: servicios.length > 1,
    speed: 500,             // tiempo animación en ms
    slidesToShow: Math.min(4, servicios.length),
    slidesToScroll: 1,
    autoplay: true,         // activa auto slide
    autoplaySpeed: 2000,    // cada 3000ms (3 segundos)
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: Math.min(3, servicios.length) }
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: Math.min(2, servicios.length) }
      }
    ]
  };

  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  // Función para obtener el componente del ícono desde string
  const getIcon = (iconName) => {
    const IconComponent = FaIcons[iconName];
    if (!IconComponent) return <FaIcons.FaRegQuestionCircle />;
    return <IconComponent />;
  };

  return (
    <>
      <NavBarServicios isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavBarMobileService isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <FloatingWhatsApp />
      <BotonFlotanteServicios onClick={() => window.location.href = '/crear-perfil-negocio'}></BotonFlotanteServicios>
      <div className="servicios-container">
        <h1>Negocios que Hacen la Diferencia</h1>

        {servicios.length === 0 ? (
          <p>No hay servicios para mostrar.</p>
        ) : (
          <Slider {...settings} className="servicios-slider">
            {servicios.map(servicio => (
              <div
                key={servicio.id}
                className="servicio-card"
                onClick={() => window.location.href = `/servicios/detalle/${servicio.id}`}
              >
                {servicio.imagenURL ? (
                  <img src={servicio.imagenURL} alt={servicio.nombre} />
                ) : (
                  <div className="imagen-fallback">No hay imagen</div>
                )}

                <div className="servicio-contenido">
                  <h3>{servicio.nombre}</h3>
                  <p className="servicio-categoria">{servicio.categoria}</p>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
      <Footer /></>
  );
};
export default ServiciosMain;
